import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { normalizeTags } from '../../models/cms-models';

@Component({
  selector: 'cms-tag-selector',
  imports: [CommonModule, FormsModule],
  templateUrl: './tag-selector.html',
  styleUrl: './tag-selector.css',
})
export class TagSelectorComponent {
  private static nextId = 0;

  @Input() label = 'Tags';
  @Input() placeholder = 'Add a tag';
  @Input() tags: string[] = [];
  @Input() suggestions: string[] = [];
  @Output() tagsChange = new EventEmitter<string[]>();

  pendingTag = '';
  readonly datalistId = `tag-selector-options-${TagSelectorComponent.nextId++}`;

  get availableSuggestions(): string[] {
    const selectedTags = new Set(this.tags.map((tag) => tag.toLowerCase()));
    return this.suggestions.filter((tag) => !selectedTags.has(tag.toLowerCase()));
  }

  addPendingTag(): void {
    const nextTags = normalizeTags([
      ...this.tags,
      ...this.pendingTag.split(','),
    ]);

    this.pendingTag = '';
    this.tagsChange.emit(nextTags);
  }

  addSuggestion(tag: string): void {
    this.tagsChange.emit(normalizeTags([...this.tags, tag]));
    this.pendingTag = '';
  }

  handlePendingTagKeydown(event: KeyboardEvent): void {
    if (event.key !== ',') {
      return;
    }

    event.preventDefault();
    this.addPendingTag();
  }

  removeTag(tag: string): void {
    this.tagsChange.emit(this.tags.filter((existingTag) => existingTag !== tag));
  }
}
